import { combineReducers } from 'redux';
import themeUsersReducer from './themeUsers/reducers';
import { readMessageReducer } from './message/reducers';
import { readNotificationReducer } from './notification/reducers';
import authReducer from './authentication/reducers';
import ChangeLayoutMode from './themeLayout/reducers';
import { headerSearchReducer } from './headerSearch/reducers';
import { ordersReducer, singleOrderReducer } from './orders/reducers';
import chartContentReducer from './chartContent/reducers';
import { productReducer, SingleProductReducer } from './product/reducers';
import { addonsReducer, singleAddonReducer } from './addon/reducers';
import { promosReducer, singlePromoReducer } from './promos/reducers';
import { settingsReducer, singleSettingReducer } from './settings/reducers';
import { customersReducer, singleCustomerReducer } from './customers/reducers';
import { addonChoicesReducer, singleAddonChoiceReducer } from './addonChoice/reducers';

const rootReducers = combineReducers({
  themeUsers: themeUsersReducer,
  headerSearchData: headerSearchReducer,
  message: readMessageReducer,
  notification: readNotificationReducer,
  orders: ordersReducer,
  order: singleOrderReducer,
  customers: customersReducer,
  customer: singleCustomerReducer,
  auth: authReducer,
  products: productReducer,
  product: SingleProductReducer,
  addons: addonsReducer,
  addon: singleAddonReducer,
  addonChoices: addonChoicesReducer,
  addonChoice: singleAddonChoiceReducer,
  promos: promosReducer,
  promo: singlePromoReducer,
  settings: settingsReducer,
  setting: singleSettingReducer,
  ChangeLayoutMode,
  chartContent: chartContentReducer,
});

export default rootReducers;
